module.exports = __webpack_public_path__ + "static/media/bg.4cca123e.png";